// extracted by mini-css-extract-plugin
module.exports = {"categoryTitle":"CategoryList_categoryTitle__3DSen"};